// extracted by mini-css-extract-plugin
export default {"collapsibleSection":"styles-module__collapsibleSection__b5e5dfc2f9440b49b5cc","isCollapsed":"styles-module__isCollapsed__a418c9ed1f4b1b74a5c5"};